import { Ds } from "@accurx/design";
import * as UI from "@accurx/design";
import styled from "styled-components";

export const StyledActionsContainer = styled(Ds.Flex).attrs({
    py: "0.5",
})`
    background-color: var(--ds-color-white);
    border-bottom: 1px solid var(--ds-color-silver);
    display: flex;
    align-items: center;
`;

export const StyledInnerActionsContainer = styled(Ds.Flex)`
    flex-grow: 1;
    max-width: ${UI.Tokens.BREAKPOINTS.md};
    margin: 0 auto;
`;

export const StyledChip = styled(Ds.Flex).attrs({
    py: "0.75",
    px: "1",
})`
    background-color: var(--ds-color-dishwater);
    border-radius: 9999px;
`;
